import React from "react";

const SvgUpdate = props => (
	<svg viewBox="0 0 200 200" {...props}>
		<g id="Obecné_ikony" data-name="Obecné ikony">
			<path d="M156.94,133.37l-32,.09c-3,0-3.93,1.67-2.21,3.72l12.42,14.7a62.58,62.58,0,0,1-97-52.26,3.75,3.75,0,0,0-7.49,0,70.08,70.08,0,0,0,109.39,58l11.92,14.11c1.74,2.05,3.55,1.35,4.05-1.55l5.45-31.59A4.33,4.33,0,0,0,156.94,133.37Z"/><path d="M100.66,29.53A69.76,69.76,0,0,0,62.29,41L50.47,27c-1.73-2-3.54-1.36-4,1.55L41,60.12a4.32,4.32,0,0,0,4.43,5.25l32.05-.09c3,0,3.94-1.68,2.21-3.73L67.15,46.73a62.61,62.61,0,0,1,96.1,52.89,3.75,3.75,0,0,0,7.49,0A70.16,70.16,0,0,0,100.66,29.53Z"/>
		</g>
	</svg>
);

export default SvgUpdate;